import { UserUrlConstant } from 'src/constants';
import {
  CloseUserDto,
  GetUserDto,
  GetUserListDto,
  GetUserListResponseDto,
  LockUserDto,
  LoginUserDto,
  LoginUserResponseDto,
  UpdateUserMfaPreferencesDto,
  UnlockUserDto,
  UpdateUserPostcloseOffersDto,
  UserDto,
  ForgotPasswordDto,
  UpdateUserDashboardSettingsDto,
} from 'src/dtos';
import { ConfigService } from 'src/services';
import { httpRequest, replacePlaceholders } from 'src/utils';

export class UsersApi {
  private _configService: ConfigService;

  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  login({ body }: LoginUserDto): Promise<LoginUserResponseDto> {
    return httpRequest<LoginUserResponseDto>({
      method: 'POST',
      url: UserUrlConstant.LOGIN,
      body,
      authToken: this._configService.authToken,
    });
  }

  list({ queryParams }: GetUserListDto): Promise<GetUserListResponseDto> {
    return httpRequest<GetUserListResponseDto>({
      method: 'GET',
      url: UserUrlConstant.LIST,
      authToken: this._configService.authToken,
      queryParams,
    });
  }

  retrieve({ params }: GetUserDto): Promise<UserDto> {
    const url = replacePlaceholders(UserUrlConstant.RETRIEVE, params);

    return httpRequest<UserDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  me(): Promise<UserDto> {
    return httpRequest<UserDto>({
      method: 'GET',
      url: UserUrlConstant.ME,
      authToken: this._configService.authToken,
    });
  }

  lock({ params }: LockUserDto): Promise<void> {
    const url = replacePlaceholders(UserUrlConstant.LOCK, params);

    return httpRequest<void>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
    });
  }

  unlock({ params }: UnlockUserDto): Promise<void> {
    const url = replacePlaceholders(UserUrlConstant.UNLOCK, params);

    return httpRequest<void>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
    });
  }

  close({ params }: CloseUserDto): Promise<void> {
    const url = replacePlaceholders(UserUrlConstant.CLOSE, params);

    return httpRequest<void>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
    });
  }

  updateUserMfaPreferences({ body, queryParams }: UpdateUserMfaPreferencesDto): Promise<void> {
    return httpRequest<void>({
      method: 'PUT',
      url: UserUrlConstant.UPDATE_USER_MFA_PREFERENCES,
      body,
      queryParams,
      authToken: this._configService.authToken,
    });
  }

  updatePostcloseOffers({ params, body }: UpdateUserPostcloseOffersDto): Promise<UserDto> {
    const url = replacePlaceholders(UserUrlConstant.UPDATE_POSTCLOSE_OFFERS, params);

    return httpRequest<UserDto>({
      method: 'PUT',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }

  forgotPassword({ body }: ForgotPasswordDto): Promise<void> {
    return httpRequest<void>({
      method: 'POST',
      url: UserUrlConstant.FORGOT_PASSWORD,
      body,
      authToken: this._configService.authToken,
    });
  }

  updateDashboardSettings({ body }: UpdateUserDashboardSettingsDto): Promise<UserDto> {
    return httpRequest<UserDto>({
      method: 'PUT',
      url: UserUrlConstant.UPDATE_DASHBOARD_SETTINGS,
      body,
      authToken: this._configService.authToken,
    });
  }
}
